import React from "react"
import { Container } from '@material-ui/core'
import { useTranslation } from "react-i18next"
import { Grid } from "@material-ui/core"
import { Field } from '@progress/kendo-react-form'
import { Label } from '@progress/kendo-react-labels'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

function UserInvitedInformationPure(props) {
    const { t } = useTranslation()

    const handlePreventReload = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
        }
    }

    return (
        <div className="full-container-register">
            <Container className='container-instructions' spacing={6} lg={12} md={12} sm={12}>
                <Grid className="register-invited-form-grid-instructions-container">
                    <Grid item xs={12}>
                        <span>{t('registerUserInvited.instructions')}</span>
                    </Grid>
                </Grid>
            </Container>
            <Container className='container' spacing={6} lg={12} md={12} sm={12} >
                <Grid container xs={12} lg={12} md={12} sm={12} es={12} spacing={2} className="register-invited-form-grid-general-container">
                    <Grid item xs={12}>
                        <Label className="register-invited-form-label">{t('registerUserInvited.formLabelNames')}</Label>
                        <Field name={'firstName'} id={'firstName'} component={props.validateInput} validator={props.validator.firstNameValidator} className="register-invited-form-filed-margin" onKeyPress={(e) => handlePreventReload(e)} required />
                    </Grid>

                    <Grid item xs={12} >
                        <Label className="register-invited-form-label" >{t('registerUserInvited.formLabelfirstLastName')}</Label>
                        <Field name={'firstLastName'} id={'firstLastName'} component={props.validateInput} validator={props.validator.firstLastNameValidator} className="register-invited-form-filed-margin" onKeyPress={(e) => handlePreventReload(e)} required />
                    </Grid>

                    <Grid item xs={12}>
                        <Label className="register-invited-form-label" >{t('registerUserInvited.formLabelSecondLastName')}</Label>
                        <Field name={'secondLastName'} id={'secondLastName'} component={props.validateInput} validator={props.validator.secondLastNameValidator} className="register-invited-form-filed-margin" onKeyPress={(e) => handlePreventReload(e)} />
                    </Grid>
                    {props.enabledSMS && <Grid item xs={12}>
                        <Label className="register-invited-form-label" >{t('registerUserInvited.formLabelCellPhoneNumber')}</Label>
                        <PhoneInput
                            placeholder="Ingresa el telefono"
                            value={props.cellphoneNumber}
                            onChange={props.onCellphoneChange}
                            defaultCountry="MX"
                            international
                            countryCallingCodeEditable={false}
                            onKeyPress={(e) => handlePreventReload(e)}
                        />
                    </Grid>}
                    {props.isCollaborator && <Grid item xs={12}>
                        <Label className="register-invited-form-label" >{t('registerUserInvited.formLabelCellPhoneNumber')}</Label>
                        <PhoneInput
                            placeholder="Ingresa el telefono"
                            value={props.cellphoneNumber}
                            onChange={props.onCellphoneChange}
                            defaultCountry="MX"
                            international
                            countryCallingCodeEditable={false}
                            onKeyPress={(e) => handlePreventReload(e)}
                        />
                    </Grid>}
                </Grid>
            </Container>
        </div>
    )
}

export { UserInvitedInformationPure as default };
